module.exports = __webpack_public_path__ + "img/correlation.8764f543.png";